<template>
    <Badge
        v-if="label || $slots.default"
        class="VerificationStatusBadge"
        :class="[{'VerificationStatusBadge--borderless': isBorderless}, `VerificationStatusBadge--${status}`]"
    >
        <slot>
            <EidIcon v-if="hasEvidentIcon" class="mr-2" :icon-src="evidentIcon" :svg-props="{ width: '15px', height:'15px' }" />
            {{ label }}
        </slot>
    </Badge>
</template>
<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import transform from 'lodash/transform';

    import evidentIcon from '@evidentid/assets-bridge/evident-icon.svg';
    import { Badge } from '@evidentid/dashboard-commons/components/Badge';
    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import {
        VerificationStatus,
        VerificationStatusLabel,
    } from '@evidentid/tprm-portal-lib/models/entity-details';

    const labels = transform(VerificationStatus, (result, val, key) => {
        result[val] = (VerificationStatusLabel as any)[key];
    }, {} as Record<VerificationStatus, VerificationStatusLabel>);

    const statusWithBorder = [
        VerificationStatus.exhausted,
        VerificationStatus.noInsuredResponse,
        VerificationStatus.actionsReview,
        VerificationStatus.producerOutreach,
        VerificationStatus.memberOutreach,
    ];

    const statusWithEvidentIcon = [
        VerificationStatus.producerOutreach,
        VerificationStatus.memberOutreach,
    ];

    @Component({
        components: { Badge, EidIcon },
    })
    export default class VerificationStatusBadge extends Vue {
        @Prop({ type: String, default: VerificationStatus.complete })
        private status!: VerificationStatus;

        public evidentIcon = evidentIcon;

        private get label(): string | null {
            return labels[this.status] || null;
        }

        private get isBorderless(): boolean {
            return !statusWithBorder.includes(this.status);
        }

        private get hasEvidentIcon(): boolean {
            return statusWithEvidentIcon.includes(this.status);
        }
    }
</script>
